export default "__VITE_ASSET__667b307c__"